import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DbTemplate, DbTemplateFilter, DbTemplateInfo } from '../db-template.model';
import { DbTemplateService } from '../db-template.service';
import { CommonService } from 'src/app/services/common.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-db-template-filter',
    templateUrl: './db-template-filter.component.html',
    styleUrl: './db-template-filter.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})

export class DbTemplateFilterComponent implements OnInit {

  @Input() dbTemplateInfo!: DbTemplateInfo;

  busyText: string = 'Indlæser filtre';
  isBusy: boolean = true;

  filters: DbTemplateFilter[] = [];  
  readFilters: DbTemplateFilter[] = [];
  deleteFilters: DbTemplateFilter[] = [];  

  // Inputfelter
  dbTemplateItemId: string = '';
  inputOperator: string = '';
  fieldValue: string = '';
  statementOperator: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private dbTemplateService: DbTemplateService,
    private commonService: CommonService
  ) { }


  async ngOnInit(): Promise<void> {
    this.filters = await this.dbTemplateService.getDbTemplateFiltre(this.dbTemplateInfo.dbTemplate.id);
    this.readFilters = this.filters.filter(f => f.section === 'read');
    this.deleteFilters = this.filters.filter(f => f.section === 'delete');

    this.dbTemplateItemId = this.dbTemplateInfo.dbTemplateItems[0].id;
    this.inputOperator = '=';
    this.statementOperator = 'AND';
    this.isBusy = false;
  }

  getFieldname(dbTemplateItemId: string) : string
  {
    const item = this.dbTemplateInfo.dbTemplateItems.filter(x=>x.id == dbTemplateItemId)[0];
    if (item != null) 
      return item.name;
    return '';
  }
  
  onFieldChange($event: Event)
  {
    this.dbTemplateItemId = ($event.target as HTMLSelectElement).value;          
  }

  onOperatorChange($event: Event)
  {
    this.inputOperator = ($event.target as HTMLSelectElement).value;          
  }

  onStatementOperatorChange($event: Event)
  {
    this.statementOperator = ($event.target as HTMLSelectElement).value;          
  }

  addFilter(section: string)
  {
    const dataItem: DbTemplateFilter = {
                                     id: this.commonService.guidEmpty(), 
                                     dbTemplateId: this.dbTemplateInfo.dbTemplate.id, 
                                    dbTemplateItemId: this.dbTemplateItemId,  
                                    fieldOperator: this.inputOperator, 
                                    fieldValue: this.fieldValue, 
                                    section: section,
                                    placement: (section == 'read' ? this.readFilters.length : this.deleteFilters.length),
                                    statementOperator: this.statementOperator};
    if (section === 'read')
    {      
      this.readFilters.push(dataItem);
    }
    else
    {
      this.deleteFilters.push(dataItem);
    }
  }

  onRemoveFilter(item: DbTemplateFilter, section: string)
  {
    if (section === 'read')
    {
      this.readFilters = this.readFilters.filter(f => f.placement !== item.placement);
      this.readFilters.forEach((f, index) => f.placement = index);
    }
    else
    {
      this.deleteFilters = this.deleteFilters.filter(f => f.placement !== item.placement);
      this.deleteFilters.forEach((f, index) => f.placement = index);
    }
  }


  saveFiltre()
  {
    this.busyText = 'Gemmer filtre';
    this.isBusy = true;
    this.filters = this.readFilters.concat(this.deleteFilters);
    this.dbTemplateService.saveDbTemplateFilter(this.dbTemplateInfo.dbTemplate.id, this.filters).then(() => {
      this.isBusy = false;
      this.activeModal.close();
    });
  }
}

